export const AuthActionType = {
  SET_USER: 'auth/SET_USER',
  LOGIN_START: 'auth/LOGIN_START',
  LOGIN_SUCCESS: 'auth/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'auth/LOGIN_FAILURE',
  LOGOUT_START: 'auth/LOGOUT_START',
  LOGOUT_COMPLETE: 'auth/LOGOUT_COMPLETE',
  CLEAR_ERROR: 'auth/CLEAR_ERROR',
}

export function createInitialAuthState(readUser) {
  return {
    user: typeof readUser === 'function' ? readUser() : null,
    loading: false,
    error: null,
  }
}

export function authReducer(state, action) {
  switch (action.type) {
    case AuthActionType.SET_USER:
      return { ...state, user: action.payload }
    case AuthActionType.LOGIN_START:
      return { ...state, loading: true, error: null }
    case AuthActionType.LOGIN_SUCCESS:
      return { ...state, loading: false, user: action.payload, error: null }
    case AuthActionType.LOGIN_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case AuthActionType.LOGOUT_START:
      return { ...state, loading: true }
    case AuthActionType.LOGOUT_COMPLETE:
      return { ...state, loading: false, user: null }
    case AuthActionType.CLEAR_ERROR:
      return { ...state, error: null }
    default:
      return state
  }
}
